import React, { type FC, useState } from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import {
	ExternalCollaboratorsSpaceInformationMessage,
	type ExternalCollaboratorsSpaceInformationMessageType,
} from './ExternalCollaboratorsSpaceInformationMessage.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	backgroundColor: token('color.background.accent.gray.subtlest'),
	padding: `${token('space.200')}`,
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	overflow: 'hidden',
});

type ExternalCollaboratorsSpaceInformationMessageBannerProps = {
	analyticsSource: string;
	messageType: ExternalCollaboratorsSpaceInformationMessageType;
	shouldShowMessageIcon: boolean;
	shouldShowAdditionalMessageContext: boolean;
	spaceKey?: string;
	wrapper: React.ComponentType<
		React.ClassAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement>
	>;
};

export const ExternalCollaboratorsSpaceInformationMessageBanner: FC<
	ExternalCollaboratorsSpaceInformationMessageBannerProps
> = (props) => {
	const [shouldShowExternalCollaborators, setShouldShowExternalCollaborators] =
		useState<boolean>(false);

	const onExternalCollaborationLoadComplete = (props) => {
		setShouldShowExternalCollaborators(props?.guestCount > 0);
	};

	const onExternalCollaborationLoadError = () => {
		setShouldShowExternalCollaborators(false);
	};

	const ParentWrapper = props?.wrapper;

	return (
		<ParentWrapper hidden={!shouldShowExternalCollaborators}>
			<Wrapper>
				<ExternalCollaboratorsSpaceInformationMessage
					{...props}
					onLoadComplete={onExternalCollaborationLoadComplete}
					onLoadError={onExternalCollaborationLoadError}
				/>
			</Wrapper>
		</ParentWrapper>
	);
};
